/* eslint @typescript-eslint/strict-boolean-expressions: off */

import { Empty } from "gui/empty/empty";
import { Spacer } from "gui/spacer/spacer";
import { DashboardList } from "gui/entries/dashboard-list";

import { useTokenFetch } from "lib/hooks/use-token-fetch";
import { fetchExampleDashboards } from "lib/entries/examples";
import { logger } from "lib/logger/browser";

import { Session } from "lib/users/types";
import { EntryDashboard } from "lib/entries/types";
import { EntryPage } from "lib/entries/types";

export default function NoFavoriteDashboards() {
  const { data, error } = useTokenFetch<EntryPage<EntryDashboard>>(
    ["favorite"],
    (_csrf: string, session?: Session) => fetchExampleDashboards(session)
  );

  if (error) {
    logger.warn(error);
    return null;
  }

  return (
    <>
      <Empty icon="circle-fill" title="No favorites yet!">
        <p>Dashboards you favorite will show up here.</p>
        {data && data.results.length > 0 && (
          <p>
            Click the star on one of the example dashboards below to get
            started.
          </p>
        )}
      </Empty>
      {data && data.results.length > 0 && (
        <>
          <Spacer size="sm" />
          <DashboardList entries={data!.results} favorites avatar color2 />
        </>
      )}
    </>
  );
}
